module.exports = __webpack_public_path__ + "static/img/7.f0535cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/7.jpg
// module id = 8Ktw
// module chunks = 1